import './Ls2BebePrematuro.scss'

const Ls2BebePrematuro = () => {
    return (
        <div className="container-fluid bg--main ps-0 ps-sm-0 ps-md-0 ps-lg-3">
            <div className="row d-flex p-0">
                <div className="col-sm-12 col-md-8 col-lg-7 col-xl-6">
                    <h1 className='titulo--lesson--color--1'>¿Qu&eacute; es un <span className='titulo--lesson--color--2'> beb&eacute; prematuro? </span></h1>

                    <div className='container py-3'>
                        <div className='row d-flex align-items-center'>
                            <div className='col-3 col-ms-4 col-md-4 col-lg-4 col-xl-2'>
                                <img src="./img/Ls2BabySilueta.png" className='' />
                            </div>
                            <div className='col-9 col-ms-8 col-md-8 col-lg-8 col-xl-10'>
                                <p className='texto--parrafo ps-lg-4 ps-xl-4'>Se considera prematuro un beb&eacute; nacido con menos de <span className='texto--span'>37 semanas de gestaci&oacute;n. </span></p>
                            </div>
                        </div>
                    </div>

                    <div className='container ps-4'>
                        <p className='texto--parrafo'>Un embarazo normal dura hasta la <span className='texto--span'>semana 40. </span> Los beb&eacute;s que nacen antes de este tiempo  <span className='texto--span'>no alcanzan a desarrollar completamente algunos de sus &oacute;rganos y sistemas </span>, como el sistema respiratorio, sistema de defensa (inmune) y sistema de regulaci&oacute;n de temperatura, entre otros.</p>
                    </div>

                    <div className='col d-block d-sm-block d-md-none style--gif-2 background--baby'>
                        <img src="./img/Ls1Baby.gif" className='img--gid-2 scale-up-center' />
                        {/* ./img/Ls1Background.png */}
                    </div>

                    <div className='container'>
                        <div className='row d-flex ps-4 pt-4'>
                            <div className='col-sm-12 col-md-12 col-lg-12 col-xl-12 d-flex style--burbuja py-2 d-flex align-items-center'>
                                <div className='col-3 col-ms-3 col-md-2 col-lg-1 col-xl-1'>
                                    <img src="./img/Ls2IconEstetoscopio.png" className='' />
                                </div>
                                <div className='col-9 col-ms-9 col-md-9 col-lg-9 col-xl-11'>
                                <p className='texto--burbuja lh-1 ps-lg-5 m-0'>Los beb&eacute;s nacidos antes de tiempo presentan mayor riesgo de infecciones respiratorias. Pregunte a su m&eacute;dico/a c&oacute;mo prevenirlas.</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* <div className='container'> pt-lg-2
                        <div className='row d-flex p-4'>
                            <div className='col-sm-12 col-md-12 col-lg-12 col-xl-10 d-flex style--burbuja py-2 align-items-center'>
                                <div className='col-3'>
                                    <img src="./img/Ls2IconEstetoscopio.png" className='' />
                                </div>
                                <div className='col-9'>
                                    <p className='texto--burbuja lh-1'>Los beb&eacute;s nacidos antes de tiempo
                                        presentan mayor riesgo de infecciones respiratorias. Pregunte a su m&eacute;dico/a c&oacute;mo prevenirlas.</p>
                                </div>
                            </div>
                        </div>
                    </div> */}

                    <div className='container p-4'>
                        <p className='texto--link'>Adaptado de: <a className='texto--link' target='_blank' href='http://www.mayoclinic.org/diseases-conditions/premature-birth/basics/definition/con-20020050'>http://www.mayoclinic.org/diseases-conditions/premature-birth/basics/definition/con-20020050</a></p>
                    </div>
                </div>
                <div className="col-md-4 d-none d-sm-none d-md-block babygif">
                    <img src="./img/Ls2BabyPrematuro.gif" className='justify-content-start img--desktop' />
                </div>
            </div>
        </div>
    )
}

export default Ls2BebePrematuro;